import React from 'react';
import Icon from '../../../components/AppIcon';

const AboutSection = ({ about }) => {
  return (
    <section className="py-12 lg:py-16 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-bold text-foreground mb-4">
            About Our Mission
          </h2>
          <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
            {about?.subtitle}
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12">
          <div className="space-y-6">
            <div className="prose prose-lg max-w-none">
              <p className="text-foreground leading-relaxed whitespace-pre-line">
                {about?.description}
              </p>
            </div>

            <div className="space-y-4 pt-4">
              <h3 className="text-xl font-semibold text-foreground">Our Core Values</h3>
              <div className="grid gap-3">
                {about?.values?.map((value, index) => (
                  <div key={index} className="flex items-start gap-3 p-4 bg-muted/50 rounded-lg">
                    <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
                      <Icon name={value?.icon} size={20} color="var(--color-primary)" />
                    </div>
                    <div>
                      <h4 className="font-semibold text-foreground mb-1">{value?.title}</h4>
                      <p className="text-sm text-muted-foreground">{value?.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="space-y-6">
            <div className="bg-card rounded-xl p-6 shadow-md border border-border">
              <h3 className="text-xl font-semibold text-foreground mb-4">
                Impact Areas
              </h3>
              <div className="space-y-4">
                {about?.impactAreas?.map((area, index) => (
                  <div key={index}>
                    <div className="flex items-center justify-between mb-2">
                      <span className="text-sm font-medium text-foreground">{area?.name}</span>
                      <span className="text-sm font-semibold text-primary">{area?.percentage}%</span>
                    </div>
                    <div className="w-full bg-muted rounded-full h-2">
                      <div
                        className="bg-gradient-to-r from-primary to-secondary h-2 rounded-full transition-all duration-500"
                        style={{ width: `${area?.percentage}%` }}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="bg-gradient-to-br from-primary/10 to-secondary/10 rounded-xl p-6 border border-primary/20">
              <h3 className="text-xl font-semibold text-foreground mb-4">
                Recognition & Certifications
              </h3>
              <div className="space-y-3">
                {about?.certifications?.map((cert, index) => (
                  <div key={index} className="flex items-center gap-3">
                    <div className="w-8 h-8 rounded-full bg-success/20 flex items-center justify-center">
                      <Icon name="Award" size={16} color="var(--color-success)" />
                    </div>
                    <div>
                      <div className="text-sm font-medium text-foreground">{cert?.name}</div>
                      <div className="text-xs text-muted-foreground">{cert?.issuer}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;